import React, { useState, useContext } from "react";
import "./Login.css";
import API from "../api/axios.js";
import { AuthContext } from "../context/AuthContext.js";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const { setToken, setUser } = useContext(AuthContext);
  const [form, setForm] = useState({ email: "", password: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post("/auth/login", form);
      setToken(res.data.token);
      setUser(res.data.user);
      navigate("/dashboard");
    } catch (error) {
      alert(error.response?.data?.message || "Login failed");
    }
  };

  return (
    <div className="login-page">

      {/* LEFT: BUSINESS INTRODUCTION */}
      <section className="login-intro">
        <div className="intro-content">
          <div className="brand">
            <h1>TruckBase</h1>
            <span>Transport Management Platform</span>
          </div>

          <h2>Digitize and control your transport operations</h2>

          <p>
            TruckBase is a centralized transport management system designed for
            fleet owners and logistics operators to manage trips, vehicles,
            drivers, billing, and bilties in a structured and reliable manner.
          </p>

          <ul className="intro-points">
            <li>Trip and vehicle management in one system</li>
            <li>Digital bilty and invoice generation</li>
            <li>Accurate records and downloadable reports</li>
            <li>Secure data access from anywhere</li>
          </ul>

          <div className="trust-bar">
            <div>
              <strong>99.9%</strong>
              <span>System Availability</span>
            </div>
            <div>
              <strong>24/7</strong>
              <span>Operational Support</span>
            </div>
          </div>
        </div>
      </section>

      {/* RIGHT: LOGIN */}
      <section className="login-panel">
        <div className="login-card">
          <h3>Sign in</h3>
          <p className="login-subtitle">
            Access your TruckBase dashboard
          </p>

          <form onSubmit={handleSubmit}>
            <label>Email address</label>
            <input
              type="email"
              placeholder="name@company.com"
              onChange={(e) =>
                setForm({ ...form, email: e.target.value })
              }
            />

            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              onChange={(e) =>
                setForm({ ...form, password: e.target.value })
              }
            />

            <button type="submit">Sign in</button>
          </form>

          <p className="register-link" onClick={() => navigate("/register")}>
            New to TruckBase? Create an account
          </p>
        </div>
      </section>

    </div>
  );
};

export default Login;
